"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
//
// assets
//
const ordersCopy_1 = require("copy/ordersCopy");
const DateFormat_1 = require("components/general/utility/DateFormat");
//
// components
//
const ModalTable_1 = __importDefault(require("components/Dashboard/Tables/ModalTable"));
//
// styles
//
const ModalTable_2 = require("components/Dashboard/Tables/ModalTable");
const StyledModalHeader_1 = require("components/Dashboard/Modals/StyledModalHeader");
const StyledSectionContainer_1 = require("components/Dashboard/Modals/StyledSectionContainer");
const StyledSubHeader_1 = require("components/Dashboard/Modals/StyledSubHeader");
const StyledModalCard_1 = require("components/Dashboard/Modals/StyledModalCard");
const StyledCardHeader_1 = require("components/Dashboard/Modals/StyledCardHeader");
const StyledTableContainer_1 = require("components/Dashboard/Modals/StyledTableContainer");
const StyledCloseIcon_1 = require("components/Dashboard/Modals/StyledCloseIcon");
const OrderModal = (props) => {
    (0, react_1.useEffect)(() => {
        if (props.display) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.removeAttribute('style');
        }
    }, [props.display]);
    function handleClick(event) {
        if (event.target.id === 'modal-root') {
            props.handleToggleModal();
        }
    }
    const issues = props.order.issues.edges.filter((issue) => issue.node.rule.name === 'FulfillmentStalled');
    return (react_1.default.createElement("div", { "aria-hidden": 'true', className: 'modal fade show', id: 'modal-root', onClick: handleClick, role: 'dialog', style: {
            display: `${props.display ? 'block' : 'none'}`
        }, tabIndex: -1 },
        react_1.default.createElement("div", { className: 'modal-dialog modal-dialog-centered modal-container', role: 'document' },
            react_1.default.createElement("div", { className: 'modal-content' },
                react_1.default.createElement(StyledModalCard_1.StyledModalCard, { className: 'modal-card card' },
                    react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', padding: '12px 30px', top: true },
                        react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, null,
                            react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-number' }, `Order ${props.order.number}`),
                            react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { className: 'card-header-title date-time' }, `${(0, DateFormat_1.hourlyFormat)(props.order.insertedAt)}, ${(0, DateFormat_1.twoDigitDateFormat)(props.order.insertedAt)}`)),
                        react_1.default.createElement("button", { "aria-label": 'Close', className: 'close', "data-dismiss": 'modal', onClick: props.handleToggleModal, type: 'button' },
                            react_1.default.createElement(StyledCloseIcon_1.StyledCloseIcon, { "aria-hidden": 'true' }, "\u00D7"))),
                    react_1.default.createElement(StyledCardHeader_1.StyledCardHeader, { className: 'card-header', height: issues.length > 0 ? 'auto' : '80px', padding: '12px 30px', top: true },
                        react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { height: '100%', justify: 'space-evenly' },
                            react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { direction: 'row', margin: '0 0 10px' },
                                react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { half: true },
                                    react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { className: 'card-header-title' }, ordersCopy_1.ordersCopy.column2),
                                    react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-name' }, props.order.customer &&
                                        props.order.customer.firstName &&
                                        props.order.customer.lastName
                                        ? `${props.order.customer.firstName} ${props.order.customer.lastName}`
                                        : '─')),
                                react_1.default.createElement(StyledSectionContainer_1.StyledSectionContainer, { half: true },
                                    react_1.default.createElement(StyledSubHeader_1.StyledSubHeader, { className: 'card-header-title' }, ordersCopy_1.ordersCopy.column3),
                                    react_1.default.createElement(StyledModalHeader_1.StyledModalHeader, { className: 'card-header-title order-email' }, props.order.customer && props.order.customer.email
                                        ? props.order.customer.email
                                        : '─'))),
                            issues.map((issue) => (react_1.default.createElement(ModalTable_2.IssueDisplay, { issue: issue.node, key: issue.node.id }))) || null)),
                    react_1.default.createElement(StyledTableContainer_1.StyledTableContainer, { className: 'card-body' },
                        react_1.default.createElement(ModalTable_1.default, { data: props.order })))))));
};
exports.default = OrderModal;
